export { default } from './TeamChatMessage';
